
import axios from 'axios'

const api = axios.create({
baseURL: 'https://osakadmin.zaitunsoftsolutions.com/:2050',
// baseURL: 'http://localhost:5009'
});

export default api

// import axios from 'axios';

// const { hostname } = window.location;

// let baseURL;

// if (hostname === 'univhr.unitdtechnologies.com') {
//   baseURL = 'http://66.29.154.85:3005';
// } else {
//   baseURL = 'http://localhost:3005';
// }

// console.log('Selected Base URL:', baseURL);

// const api = axios.create({
//   baseURL,
// });

// export default api;